import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {select} from '@angular-redux/store';
import {INITIAL_STATE} from '../../../store/IAppState';
import {Observable} from 'rxjs';
import {FeatureToggleSetting, GmapMarker, ZipCodeNewPatientVisits} from '../../../shared/models';
import {distinctUntilChanged} from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  selector: 'app-zip-code-overview-tile',
  templateUrl: './zip-code-overview-tile.component.html',
  styleUrls: ['./zip-code-overview-tile.component.scss']
})
export class ZipCodeOverviewTileComponent implements OnInit, AfterViewInit {

  showProgressBar = false;
  zipCodeNewPatientVisits: ZipCodeNewPatientVisits[] = [];
  gmapMarkerData: GmapMarker[] = [];
  level: string;
  tableTitle = 'Top New Patient Visit Zip Codes';
  zipCodeColumns: any[] = [
    {
      columnDef: 'id', header: '#',
      dataName: (row: any) => `${(row != null && row.id != null) ? row.id.toString() : ''}`
    },
    {
      columnDef: 'zipCode', header: 'Zip Code',
      dataName: (row: any) => `${(row != null && row.zipCode != null) ? row.zipCode.toString() : ''}`
    },
    {
      columnDef: 'newPatientVisitPercentage', header: '% New Patient Visits',
      dataName: (row: any) => `${(row != null && row.newPatientVisitPercentage != null)
        ? row.newPatientVisitPercentage.toString() : ''}`
    },
    {
      columnDef: 'newPatientVisitCount', header: '# of New Patients',
      dataName: (row: any) => `${(row != null && row.newPatientVisitCount != null) ?
        row.newPatientVisitCount.toString() : ''}`
    },
    {
      columnDef: 'totalPatientVisitCount', header: '# of Total Patients',
      dataName: (row: any) => `${(row != null && row.totalPatientVisitCount != null) ?
        row.totalPatientVisitCount.toString() : ''}`
    }
  ];

  @select(['data', 'zipCodeNewPatientVisits'])
  private readonly zipCodeNewPatientVisits$: Observable<ZipCodeNewPatientVisits[]>;

  @select(['data', 'featureToggleSettings'])
  private readonly featureToggleSettings$: Observable<FeatureToggleSetting[]>;

  @Input() fromPdfExport = false;

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.zipCodeNewPatientVisits$.pipe(distinctUntilChanged((type1, type2) => _.isEqual(type1, type2)))
      .subscribe((zipCodeNewPatientVisits: ZipCodeNewPatientVisits[]) => {
        this.zipCodeNewPatientVisits = _.take(zipCodeNewPatientVisits, 10);
        this.gmapMarkerData = [];
        this.level = '';
        let index = 1;
        this.zipCodeNewPatientVisits.forEach(x => {
          this.gmapMarkerData.push({
            id: index ++,
            lat: +x.lat,
            lng: +x.lng,
            zipCode: x.zipCode,
            newPatientVisitCount: x.newPatientVisitCount,
            newPatientVisitPercentage: x.newPatientVisitPercentage + '%',
            totalPatientVisitCount: x.totalPatientVisitCount
          });
        });
        this.showProgressBar = _.isEqual(zipCodeNewPatientVisits, INITIAL_STATE.data.zipCodeNewPatientVisits);
        this.cdr.detectChanges();
      });
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
}
